const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]').val()
    .replace(/page(_\w+)?=\d+/g, 'page$1=' + currentPage)
    .replace(/([?&])phcursor=[^&]*/g, '');  
  
  const nextUrlScroll = $('[data-next-url]').val()
    .replace(/page(_\w+)?=\d+/g, 'page$1=' + currentPageScroll)
    .replace(/([?&])phcursor=[^&]*/g, ''); 

  console.log(nextUrl)
  console.log(nextUrlScroll)
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());

      // colorSwatches();
    },
    complete: function () {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } else {
        button.remove();
      }
      sessionStorage.setItem('dynamicContent', $('.load-more-grid').html());
      sessionStorage.setItem('pageInfo', $('.page-hidden-info').html());
      updateDiscountPrice ? updateDiscountPrice() : null;

    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();


}

(function () {
  loadMore();
  let navigationType;
  
  const navigationEntries = performance.getEntriesByType('navigation');
  if (navigationEntries.length > 0) {
    navigationType = navigationEntries[0].type;
  } 

  if (navigationType == 'back_forward') {
    console.log("------------back to history-------------");
    window.addEventListener('load', () => {
      const savedContent = sessionStorage.getItem('dynamicContent');
      const savedPageInfo = sessionStorage.getItem('pageInfo');
      if (savedContent && savedContent != "null") {
        document.querySelector('.load-more-grid').innerHTML = savedContent;
        document.querySelector('.page-hidden-info').innerHTML = savedPageInfo;

      }
    });
  } else {
    console.log("------------Not history-------------");
    sessionStorage.setItem('dynamicContent', null);
  }
})();


